import {
  DELETE_TIMER_INFO,
  UPDATE_TIMER_INFO
} from "../constants/doctorsQueue";

export const updateTimer = data => ({
  type: UPDATE_TIMER_INFO,
  payload: data
});

export const deleteTimer = data => ({
  type: DELETE_TIMER_INFO,
  payload: data
});
